var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5ZM17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5ZM5.5 18C5.5 17.6806 5.61315 17.4384 5.85962 17.2099C6.13462 16.9549 6.58426 16.7153 7.22866 16.5192C8.51906 16.1265 10.2719 16 12 16C12.6906 16 14.4583 16.12 15.9559 16.5808C16.7113 16.8132 17.2986 17.1031 17.6554 17.4275C17.9701 17.7135 18.0724 17.983 18.0136 18.3357C17.9974 18.4326 17.9221 18.6105 17.6111 18.8431C17.299 19.0766 16.8247 19.305 16.1935 19.5004C14.9354 19.8897 13.2522 20.0872 11.5492 20.0579C9.84206 20.0286 8.21087 19.7732 7.04377 19.323C5.78707 18.8383 5.5 18.3212 5.5 18ZM12 14C10.2281 14 8.23093 14.1236 6.64633 14.6058C5.85324 14.8472 5.08413 15.2014 4.49975 15.7433C3.88685 16.3116 3.5 17.0695 3.5 18C3.5 19.6787 4.95278 20.6601 6.32401 21.189C7.78484 21.7525 9.66967 22.026 11.5149 22.0576C13.3642 22.0894 15.2697 21.8798 16.7848 21.411C17.5402 21.1772 18.2487 20.8638 18.809 20.4447C19.3704 20.0247 19.8572 19.4394 19.9864 18.6645C20.1776 17.5171 19.7174 16.599 19.0008 15.9476C18.3264 15.3344 17.4137 14.9368 16.5441 14.6692C14.7917 14.13 12.8094 14 12 14Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccount);
export default __webpack_public_path__ + "static/media/ic-account.978305df80b1c0d9818cde38bbcfe4a1.svg";
export { ForwardRef as ReactComponent };